import { useEffect, useRef, useState } from "react";
import { Wand2 } from "lucide-react";

export const MagicCursor = () => {
  const [enabled, setEnabled] = useState(false);
  const wandRef = useRef(null);
  const [sparkles, setSparkles] = useState([]);

  useEffect(() => {
    if (!window.matchMedia("(pointer: fine)").matches) return;
    setEnabled(true);
    let id = 0;
    const move = (e) => {
      if (wandRef.current) {
        wandRef.current.style.transform = `translate(${e.clientX + 12}px, ${e.clientY + 10}px) rotate(-12deg)`;
      }
      id += 1;
      if (id % 7 === 0) {
        const s = { id, x: e.clientX + 8, y: e.clientY + 6 };
        setSparkles((prev) => [...prev.slice(-14), s]);
        setTimeout(() => setSparkles((prev) => prev.filter((p) => p.id !== s.id)), 650);
      }
    };
    window.addEventListener("mousemove", move, { passive: true });
    return () => window.removeEventListener("mousemove", move);
  }, []);

  if (!enabled) return null;

  return (
    <>
      <div
        ref={wandRef}
        aria-hidden="true"
        data-testid="magic-wand-cursor"
        className="pointer-events-none fixed left-0 top-0 z-[70] text-gold-500 drop-shadow-[0_0_6px_rgba(212,175,55,0.8)] transition-transform duration-75 ease-out"
      >
        <Wand2 size={20} />
      </div>
      {sparkles.map((s) => (
        <span
          key={s.id}
          aria-hidden="true"
          className="sparkle-fade pointer-events-none fixed z-[70] h-1.5 w-1.5 rounded-full bg-gold-400"
          style={{ left: s.x, top: s.y }}
        />
      ))}
    </>
  );
};
